var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('van-empty',{attrs:{"description":_vm.langUtil(84)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }